import React, { FC } from 'react'
import { Rating } from '@moonpig/launchpad-components'
import { useFindLocaleText } from '../../../text-localisation'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

export const RatingModule: FC<ProductModule> = props => {
  const [
    {
      product: { rating },
    },
  ] = useProductContext()
  const t = useFindLocaleText()

  return rating ? (
    <ProductModuleSection {...props}>
      <Rating
        rating={rating.score}
        totalRatingsText={
          rating.count ? `(${t('find.rating_count', rating.count)})` : undefined
        }
        totalRatingsScreenReaderText={
          rating.count ? t('find.total_reviews') : undefined
        }
        starSize={24}
      />
    </ProductModuleSection>
  ) : null
}
